<div class="page-title-area">
  <div class="d-table">
      <div class="d-table-cell">
          <div class="container">
              <div class="page-title-text">
                  <h2>Search Results</h2>
                  <ul>
                      <li><a routerLink="/">Home</a></li>
                      <li><i class="icofont-simple-right"></i></li>
                      <li>Search</li>
                  </ul>
              </div>
          </div>
      </div>
  </div>
</div>

<div class="dashboard-area pt-100">
  <div class="container">
      <div class="create-information">
          <form [formGroup]="sform" (ngSubmit)="performSearch()">
              <h3>{{title}}</h3>

              <div class="row">
                <!-- Service Category -->
                <div class="col-lg-6">
                  <div class="form-group">
                      <label for="serviceCategoryId">ServiceName/Keyword</label>
                      <input type="text" class="form-control"
                      id="name" placeholder="service name or keyword"
                      formControlName="name"
                      [ngClass]="{'is-invalid': displayMessage.name }">
                      <span class="invalid-feedback">
                        {{displayMessage.name}}
                      </span>
                  </div>
                </div>
                <!-- Service Name -->
                <div class="col-lg-6">
                  <div class="form-group">
                      <label for="name">City</label>
                      <input type="text" class="form-control"
                      id="name" placeholder="service name or a person"
                      formControlName="city"
                      [ngClass]="{'is-invalid': displayMessage.city }">
                      <span class="invalid-feedback">
                        {{displayMessage.city}}
                      </span>
                  </div>
                </div>
              </div>

              <div class="text-left">
                <button type="submit" class="btn create-ac-btn"
                  [title]="sform.valid"
                  [disabled]="!sform.valid">
                  Search</button>
              </div>

          </form>
      </div>

  </div>
</div>

